'use client'

import { useUserPrefs } from '@/context/UserPrefsContext'
import { DeviceOrientationControls, OrbitControls } from '@react-three/drei'
import { memo, useMemo } from 'react'

function Controls() {
  const { userPrefs } = useUserPrefs()
  const { isMobile, hasGyro, useGyro } = userPrefs

  // Memoize controls to prevent re-mounting when parent re-renders
  // This is critical on mobile where DeviceOrientationControls event listeners
  // can only be added with user permission (iOS 13+) and will fail if re-added
  // outside of a user gesture context
  const controls = useMemo(() => {
    if (isMobile && hasGyro && useGyro) {
      // makeDefault registers this control in the drei store, helping stabilize it
      return <DeviceOrientationControls makeDefault />
    }
    return (
      <OrbitControls
        makeDefault
        target={[1, 0, 0]}
        enableZoom={false}
        enablePan={false}
        enableDamping={false}
        rotateSpeed={0.5}
      />
    )
  }, [isMobile, hasGyro, useGyro])

  return <>{controls}</>
}

// Wrap with React.memo to prevent re-renders when parent components update
// This further protects the DeviceOrientationControls from losing event listeners
export default memo(Controls)
